import { React, useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import {getAgentTimeSlotsService, schedulePropertyVisitAgentAudit } from "../../../services/SchedulePropertyVisit";
import {
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useFormik } from "formik";
import { agentDashboardSelector } from "../../../redux/agentDashboard";

import { GetAllPropertyToBeAuditedData, GetAllPropertyScheduledForAuditData } from "../../../services/propertyScheduledForVisit";
import CustomSelect from "../../../components/CustomSelect";
const ScheduleAuditVisitAgent = ({id,setSchedAppointment}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [slotsList, setSlotsList] = useState([]);
  const { propertyToBeAuditedData } = useSelector(agentDashboardSelector);
  const { t } = useTranslation();
  const { propertyScheduledForAuditedData } = useSelector(
    agentDashboardSelector
  );
  useEffect(() => {
    getTimeSlotsList();
    
  }, [])
  const getMyPropertyList = () => {
    dispatch(GetAllPropertyToBeAuditedData());
  };
  const getMyPropertyListScheduledForAudit = () => {
    dispatch(GetAllPropertyScheduledForAuditData());
  };
  const getTimeSlotsList = async () => {
    try{
      setLoading(true);
      let data = await getAgentTimeSlotsService();
      let slotList = data?.map((item, index) => {
        return { label: item?.slot_from + "-" + item?.slot_to, value: item?.id, item }
         
      });
      setSlotsList(slotList);
      throw data;
    } catch (e) {
      console.log(e, "error");
      setLoading(false);
    }
  }
   const handleFormSubmit = async (values, { resetForm }) => {
      try{
        setLoading(true);
        let payload = {
          ...values,
          property_id: id,
          schedule_date_2: formik.values.schedule_date_2?.value,
          schedule_date_3: formik.values.schedule_date_3?.value,
          timeslot: formik.values.timeslot?.value,
          timeslot_2: formik.values.timeslot_2?.value,
          timeslot_3: formik.values.timeslot_3?.value,
        };
        let data = await schedulePropertyVisitAgentAudit(payload);
        if (data) {
          setSchedAppointment(false)
          setLoading(false);
          resetForm();
          getMyPropertyList();
    getMyPropertyListScheduledForAudit();
        }
        throw data;
      } catch (e) {
        console.log(e, "error");
        setLoading(false);
      }
  };

  const formik = useFormik({
    initialValues: {
      schedule_date: "",
      schedule_date_2: "",
      schedule_date_3: "",
      timeslot: null,
      timeslot_2: null,
      timeslot_3: null,
    },
    validationSchema: Yup.object({
      schedule_date: Yup.string().required("Please Select Prefferred date "),
      timeslot: Yup.object().test('timeslot', 'Please select a valid time slot.', function(value) {     // 'value' is the value of the 'timeslot' field    
        return !!value  }),
    }),
    onSubmit: handleFormSubmit,
  });
  return (
    <>
      <form onSubmit={formik.handleSubmit} noValidate>
        <Box component="div" sx={{ width: "100%", padding: "8px 24px" }}>
          <Typography
            variant="mSize"
            component="h5"
            className="font-w-600 line-h-extended-1"
            sx={{ textAlign: "center" }}
          >
            {t("Schedule for Audit")}
          </Typography>

          <Box component="div" className="schedule-visit-container">
            <Box component="div" className="select-date">
              <label htmlFor="date-1">{t("Agent_dashboard.Preference Date")}({t("Agent_dashboard.Mandatory")})</label>
              <input
                type="date"
                id="date-1"
                className="form-control"
                placeholder="select date"
                min={new Date().toISOString().split('T')[0]} 
                // onChange={(newValue) => formik.setFieldValue('schedule_date', newValue)}
                onChange={(e) => formik.handleChange(e)}
                value={formik.values.schedule_date}
                name="schedule_date"
              />
            </Box>
            <Box component="div" className="select-time">
              <label htmlFor="slot-1">{t("Agent_dashboard.Select Slot")}</label>
              <CustomSelect
                options={slotsList}
                width={"100%"}
                dropDownZIndex={100000}
                placeholder={t("Agent_dashboard.Select Slot")}
                labelShrink={true}
                controlStyle={{
                  padding: 5,
                  height: 56,
                  borderTop: "none",
                  borderLeft: "none",
                  borderRight: "none",
                  borderColor: "#dcdcdc",
                }}
                name="timeslot"
                value={ formik.values.timeslot }
                handleChange={(e) => {
                  formik.setValues((values) => {
                    return {
                      ...values,
                      timeslot: e
                    }
                  })
                }}
                defaultOptions
                isClearable={true}
                error={formik.touched.timeslot && Boolean(formik.errors.timeslot)}
                helperText={formik.touched.timeslot && formik.errors.timeslot}
              />
            </Box>
          </Box>
          <Box
            component="div"
            className="btn_container"
            sx={{ textAlign: "center" }}
          >
            <Button className=" reset-btn" onClick={formik.resetForm}>
            {t("Agent_dashboard.Reset")}
            </Button>
            <Button
              className="apply-btn font-w-600 "
              variant="sSize"
              type="submit"
            >
             {t("Agent_dashboard.Apply")}
            </Button>
          </Box>
        </Box>
      </form>
    </>
  );
};

export default ScheduleAuditVisitAgent;
